import {
  GET_CLIENT_PROFILE,
  GET_CLIENT_PROFILE_FAIL,
  GET_CLIENT_PROFILE_SUCCESS,
  GET_CLIENTS,
  GET_CLIENTS_FAIL,
  GET_CLIENTS_SUCCESS,
  ADD_NEW_CLIENT,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_FAIL,
  UPDATE_CLIENT,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAIL,
  DELETE_CLIENT,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL,
  ADD_PARTNER,
  ADD_PARTNER_SUCCESS,
  ADD_PARTNER_FAIL,
} from "./actionTypes"

export const getClients = ({offset='',page_size='',query=''}) => ({
  type: GET_CLIENTS,
  payload:{offset,page_size,query}
})

export const getClientsSuccess = clients => ({
  type: GET_CLIENTS_SUCCESS,
  payload: clients,
})

export const getClientsFail = error => ({
  type: GET_CLIENTS_FAIL,
  payload: error,
})

export const addNewClient = (client,history) => ({
  type: ADD_NEW_CLIENT,
  payload: {client,history},
})

export const addClientSuccess = user => ({
  type: ADD_CLIENT_SUCCESS,
  payload: user,
})  

export const addClientFail = error => ({
  type: ADD_CLIENT_FAIL,
  payload: error,
})

export const addNewPartner = (client) => ({
  type: ADD_PARTNER,
  payload: client,
})

export const addPartnerSuccess = user => ({
  type: ADD_PARTNER_SUCCESS,
  payload: user,
})  

export const addPartnerFail = error => ({
  type: ADD_PARTNER_FAIL,
  payload: error,
})

export const updateClient = (client,history) => ({
  type: UPDATE_CLIENT,
  payload: {client,history},
})

export const updateClientSuccess = user => ({
  type: UPDATE_CLIENT_SUCCESS,
  payload: user,
})

export const updateClientFail = error => ({
  type: UPDATE_CLIENT_FAIL,
  payload: error,
})

export const deleteClient = user => ({
  type: DELETE_CLIENT,
  payload: user,
})

export const deleteClientSuccess = user => ({
  type: DELETE_CLIENT_SUCCESS,
  payload: user,
})

export const deleteClientFail = error => ({
  type: DELETE_CLIENT_FAIL,
  payload: error,
})

export const getClientProfile = () => ({
  type: GET_CLIENT_PROFILE,
})

export const getClientProfileSuccess = userProfile => ({
  type: GET_CLIENT_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getClientProfileFail = error => ({
  type: GET_CLIENT_PROFILE_FAIL,
  payload: error,
})
